module.exports = __webpack_public_path__ + "static/media/bf5.02cc6e2a.png";